/**
 * ユーザー管理ページ
 * システムユーザーの登録・編集・権限管理
 */

import { OptimizedUserTable } from '@/features/users/components/OptimizedUserTable'
import { Toaster } from '@/shared/ui/sonner'
import { Card, CardContent } from '@/shared/ui/card'
import { AddUserDialog } from '@/features/users/components/AddUserDialog'
import { PageLayout, AdminPageWrapper } from '@/shared/components'

/**
 * ユーザー管理ページコンポーネント
 */
export default function UsersPage() {
  return (
    <AdminPageWrapper>
      <PageLayout
        title="ユーザー管理"
        description="システムユーザーの登録・編集・権限管理を行います。"
        actions={<AddUserDialog />}
      >
        <Card className="shadow-sm">
          <CardContent className="p-0">
            <OptimizedUserTable />
          </CardContent>
        </Card>
        <Toaster richColors />
      </PageLayout>
    </AdminPageWrapper>
  )
} 